<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            {{ title }}
            <el-button class="title_btn" type="primary" size="" @click="addBtn()">등록</el-button>
            <div class="clear"></div>
          </div>
          <div class="table_wrap">
            <el-table
              :data="tableData"
              style="width: 100%"
              empty-text="데이터가 없습니다."
            >
              <el-table-column
                class="table_no"
                type="index"
                label="번호"
                width="150"
                class-name="num"
                :index="tableIndex"
              >
              </el-table-column>
              <!-- <el-table-column v-for="header in tableHeader" :key="header.prop"
                               :label = header.label
                               :prop = header.prop
                               :width = header.width
                               :class-name = header.prop
              ></el-table-column> -->
              <el-table-column v-if="tableoption"
                               align="center"
                               label="내용"
              >
                <template slot-scope="scope">
                  <div v-html="scope.row.cbs_location"></div>
                </template>
              </el-table-column>
              <el-table-column v-if="tableoption"
                               align="center"
                               width="150"
                               label="옵션"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">수정</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">삭제</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import sessionStorage from '@/mixins/sessionStorage';
  import {countryType, countryList} from "@/service/countryService";
  let params = {};
  export default {
    name: "Agree",
    components: {},
    mixins: [ VuxAlert ,sessionStorage],
    data(){
      return{
        userInfo : this.getUserInfo(),
        c_idx : 1,
        category : [],
        data : {},
        title: this.$route.meta.title,
        tableData: [],
        listTotal : 0,
        page : 1,
        // tableHeader: [
        //   {
        //     label : '국가',
        //     prop : 'c_name',
        //     width : 150
        //   },
        // ],
        tableoption: true,
      }
    },
    computed: {
      tableFilter() {
        return this.tableData
      },
      filterPagnation() {
        return {
          size: 10,
          pagerCount: 11,
          total: this.tableFilter.length,
          page: 1
        }
      }
    },
    mounted() {
      this.getCountryList();
      this.getList();
    },

    methods: {
      addBtn(){
        this.$router.push('/setting/position/detail');
      },

      getCountryList(){
        this.$api.$user.getCountry()
          .then(res => { // 로그인 api 통신 후 결과 처리
            //let resultData = res.Data.result;
            // this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
            this.category = countryList;
          });
      },
      resetPage() {
        this.page = 1
      },
      async getList() {
        params = {
          page: this.page,
          c_type : 'service',
          c_idx : this.c_idx,
        }
        await this.$api.$config.getConfig(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1) {
            this.tableData = res.List;
            util.each(this.tableData, (item, index, allItems) => {
              let leng = 300;
              item.c_name = countryType[item.c_idx];
              if (item.cbs_location.length > leng) {
                item.cbs_location = item.cbs_location.substr(0, leng) + '...';
              }else{
                item.cbs_location = item.cbs_location;
              }
            });
            this.lastPage = res.Page.last_page;
            this.listTotal = res.Page.total;
          }else{
            this.tableData = [];
            this.page = 1;
            this.lastPage = 0;
            this.listTotal = 0;
          }


        })
      },
      handleEdit(index, row) {
        this.$router.push('/setting/position/detail/'+row.cs_idx);
      },
      handleDelete(index, row) {
        let alertParams = {'element' : this , 'key' : row.cs_idx };
        this.listDeleteAlert(alertParams);

      },

      dataDelete(key){
        let params = {'cs_idx' : key , c_type : 'service' , cbs_location:1}
        this.$api.$config.deleteConfig(params).then( res => res.Data.Result).then(res => {
          if(res.Info.Type === 1){
            this.page = 1;
            let alertParams = {'element' : this  };
            this.deleteAlert(alertParams);
          }else{
            this.errorAlert(res.Info.reason);
          }
        })
      },


      tableIndex(index) {
        return index+1
      },
    }
  }
</script>

